import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import Loading from "./pages/Loading";
import Dashboard from "./pages/Dashboard";
import Orgs from "./pages/Orgs";
import Barkprints from "./pages/Barkprints";
import Demos from "./pages/Demos";
import Applicants from "./pages/Applicants";
import Webhooks from "./pages/Webhooks";
import Org from "./pages/Org";
import OrgAddCard from "./components/Forms/OrgAddCard";
import RegisterNewUser from "./pages/RegisterNewUser";
import AccessKeys from "./pages/AccessKeys";
import Messages from "./pages/Messages";
import Reports from "./pages/Reports";
import Downloads from "./pages/Downloads";
import PageContent from "./pages/PageContent";
import ManageMFA from "./pages/ManageMFA";


import Logs from "./pages/Logs";
import UsersPage from "./pages/UsersPage";

import UserAccount from "./pages/UserAcount";
import AdminUserAccount from "./pages/AdminUserAcount";
import AdminRegisterNewUser from "./pages/AdminRegisterNewUser";
import AdminUsersPage from "./pages/AdminUsersPage";

import { NavElementsLayout } from "./components/Layout/NavElements";


import { useState, useEffect } from "react";
import { UserContext } from "./contexts/user";

import { CssBaseline, Box } from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import Cookies from 'universal-cookie';

import axios from "axios";

export const API_URL = "http://api.rtta.2t-security.co.uk";

export const mdTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#A020F0",
    },
  },
});

function App() {

  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState({
    username: ""
  });

  useEffect(() => {
    axios
      .post(`${API_URL}/session`)
      .then((res) => {
        if (res.data.username !== 'not logged in'){
          setUser({
            username: res.data.username
          });
          
        }
        setLoading(false)
      })
  }, []);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box id="a" sx={{ display: "flex" }}>
        <CssBaseline />
        <BrowserRouter>
          <UserContext.Provider value={{ user, setUser }}>
                <Routes>
                  <Route index element={<LoginPage />} />
                    {loading ? <Route path="*" element={<Loading />} /> :
                    user.username === "" ? <Route path="*" element={<LoginPage />} /> :
                    <Route path="/" element={<NavElementsLayout />}>
                      <Route path="dashboard" element={<PageContent content={<Dashboard />} />}/>
                      <Route path="users" element={<PageContent content={<UsersPage />} />}/>
                      <Route path="users/:user" element={<PageContent content={<UserAccount />} />}/>
                      <Route path="register_new_user"element={<PageContent content={<RegisterNewUser/>} />} />
                      <Route path="register_new_user/:applicant_id"element={<PageContent content={<RegisterNewUser/>} />} />
                      <Route path="orgs" element={<PageContent content={<Orgs />} />}/>
                      <Route path="orgs/:org_id" element={<PageContent content={<Org />} />}/>
                      <Route path="add_org" element={<PageContent content={<OrgAddCard />} />}/>
                      <Route path="barkprints" element={<PageContent content={<Barkprints />} />}/>
                      <Route path="demos" element={<PageContent content={<Demos />} />}/>
                      <Route path="applicants" element={<PageContent content={<Applicants />} />}/>
                      <Route path="webhooks" element={<PageContent content={<Webhooks />} />}/>
                      <Route path="accessKeys" element={<PageContent content={<AccessKeys />} />}/>
                      <Route path="messages" element={<PageContent content={<Messages />} />}/>
                      <Route path="downloads" element={<PageContent content={<Downloads />} />}/>
                      <Route path="reports" element={<PageContent content={<Reports />} />}/>
                      <Route path="logs" element={<PageContent content={<Logs />} />}/>
                      <Route path="manageMFA" element={<PageContent content={<ManageMFA />} />}/>
                      <Route path="admin_users" element={<PageContent content={<AdminUsersPage />} />}/>
                      <Route path="admin_users/:adminUser" element={<PageContent content={<AdminUserAccount />} />}/>
                      <Route path="admin_register_new_user"element={<PageContent content={<AdminRegisterNewUser/>} />} />
                      <Route path="*" element={<PageContent content={<p>404 page not found</p>} />}/>
                    </Route>
}
                </Routes>
          </UserContext.Provider>
        </BrowserRouter>
      </Box>
    </ThemeProvider>
  );
}

export default App;
